export enum PermissionType {
  geolocation = 'geolocation'
}

export async function checkPermission(type: PermissionType): Promise<boolean> {
  return new Promise((resolve) => {
    if (!navigator.permissions) {
      resolve(false);
    } else {
      navigator.permissions.query({ name: type }).then((status: PermissionStatus) => {
        if (status.state === 'granted') {
          resolve(true);
        } else {
          resolve(false);
        }
      }).catch(() => {
        resolve(false);
      })
    }
  })
}
